import React from 'react';

const NqmGuidelineInstructions = () => {
  return (
    <>
      <h2>NQM Investor Guideline Q&A</h2>
      <br />
      <br />
      <ul>
        <li>This is a GPT-enabled investor guideline search.</li>
        <li>
          By default, the response is limited to the <b>FMHL</b> guidelines.
          <ul>
            <li>
              To list the available investor guidelines, type '<b>index</b>'.
            </li>
            <li>
              To search a specific investor's guidelines, mention the investor's
              name.
            </li>
            <li>
              To search across all investors, mention '<b>all investors</b>' or
              '<b>any investor</b>'.
            </li>
          </ul>
        </li>
        <li>
          To limit your search to loan program matrices, include '<b>matrix</b>'
          in your question.
        </li>
        <li>
          Enter USD amounts using this format: <b>$2.5M</b>.
        </li>
      </ul>
    </>
  );
};

export default NqmGuidelineInstructions;
